import { render, staticRenderFns } from "./SchoolPage.vue?vue&type=template&id=79e54fd2"
import script from "./js/school.js?vue&type=script&lang=js&external"
export * from "./js/school.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports